export const siteLinks = {
  assessment: "#assessment-form",
  coachRxCheckout: "https://calendly.com/lt-creative-llc25/30min",
  instagram: "#footer",
  tiktok: "#footer",
  privacy: "#footer",
  terms: "#footer",
  contact: "mailto:hello@leotovarmethod.com",
} as const;

export const brandAssets = {
  logo: "https://cdn.magicpatterns.com/uploads/ddm3FSYiNjGf3MoKkCMXqf/Imagen_de_ChatGPT_6_oct_2026,_11_41_18-4.png",
  hero: "https://cdn.magicpatterns.com/uploads/vjfndZyrWZP2vACJH1Eujm/Imagen_de_ChatGPT_6_oct_2026,_17_14_09-6.png",
  about: "https://cdn.magicpatterns.com/uploads/1GkKAXBrD1fe1W6e3tPtmg/Imagen_de_ChatGPT_6_oct_2026,_17_14_05-3.png",
} as const;

export const navigation = [
  { label: "Method", href: "#method" },
  { label: "Assessment", href: "#assessment" },
  { label: "Online Coaching", href: "#online-coaching" },
  { label: "Denver Coaching", href: "#denver-coaching" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
] as const;

export const philosophy = [
  { title: "MOVE", words: "Strength • Mobility • Control", description: "Move well. Build useful strength." },
  { title: "MIND", words: "Awareness • Confidence • Discipline", description: "Train with clarity and consistency." },
  { title: "SPIRIT", words: "Connection • Presence • Growth", description: "Build trust in your body." },
  { title: "PURPOSE", words: "Intention • Direction • Meaning", description: "Know what you are training for." },
] as const;

export const methodSteps = [
  { number: "01", title: "Assess", body: "Understand how you move." },
  { number: "02", title: "Build", body: "Create the right strategy." },
  { number: "03", title: "Perform", body: "Develop strength and capability." },
  { number: "04", title: "Evolve", body: "Adjust as you progress." },
] as const;

export const bodyAreas = ["Knees", "Ankles", "Hips", "Back", "Shoulders", "Neck"] as const;

export const coachingPaths = [
  {
    id: "online-coaching",
    name: "Online coaching",
    description: "Personalized programming, progression and accountability while you train independently.",
    features: ["Individualized programming", "Strength and movement work", "Mobility", "Check-ins", "Program adjustments", "Coach communication"],
    cta: "Start your assessment",
  },
  {
    id: "denver-coaching",
    name: "Denver 1:1 coaching",
    description: "Private, hands-on coaching with movement feedback and individualized training.",
    features: ["Private sessions", "Movement coaching", "Strength development", "Mobility", "Technique", "Progress tracking"],
    cta: "Start your assessment",
  },
] as const;

export const faqItems = [
  { question: "What happens during the assessment?", answer: "Leo reviews how you move, including movement patterns, mobility, stability and control, alongside your history, current limitations and goals." },
  { question: "Is the assessment paid?", answer: "Yes. The assessment is a professional service and the required first step of the Leo Tovar Method." },
  { question: "What happens after I submit the short form?", answer: "You continue to the secure CoachRx checkout. After payment, you receive access to choose your assessment time and complete the full intake." },
  { question: "Do I need training experience?", answer: "No. The assessment meets you where you are, whether you are beginning, returning or already training consistently." },
  { question: "What if I have pain or previous injuries?", answer: "Share what you are experiencing so it can be considered appropriately. Coaching does not diagnose, treat or replace care from a licensed medical professional." },
  { question: "How does online coaching work?", answer: "After your assessment, Leo may recommend individualized online programming, check-ins and adjustments if that path is appropriate." },
  { question: "Where is 1:1 coaching available?", answer: "Private in-person coaching is available in Denver. Details are provided after the assessment when the next step is recommended." },
  { question: "Can I complete the process in Spanish?", answer: "Yes. Coaching and assessments are available in English and Spanish." },
] as const;
